export default __webpack_public_path__ + "static/sp-textfield-93334a4a477db7b740f81ecd2854f35a.png";